import { getSessionId } from "../reducers/selectors";
import { useConfigurationRootState } from "./useConfigurationRootState";
/**
 * Get the session id
 * - requires {@linkcode ConfigurationController}
 * - can be empty string on startup
 * @category Hook
 * @category CsConfiguration
 * @export
 * @returns {string}
 */
export function useSessionId() {
    const ecsState = useConfigurationRootState();
    return getSessionId(ecsState);
}
//# sourceMappingURL=useSessionId.js.map